module.exports = __webpack_public_path__ + "img/modal_ribbon.17679b75.svg";